/**
 * @module cercaliagl/view/VControlButton
 */
import $ from 'jquery';
import BaseView from './BaseView';
import { createSVGIconFromPath } from './SVGUtils';

/**
 * @classdesc
 */
class VControlButton extends BaseView {
  /**
   * @param {string} iconName Icon
   * @param {Array.<string>} [paths] paths Paths
   */
  constructor(iconName, paths) {
    const classIcon = `icon-${iconName}`;
    const jqElement = $(`<div class="v-control-button" aria-pressed="false"><span class="${classIcon}" /></div>`);
    if (paths) {
      paths.forEach((path) => jqElement.find(`.${classIcon}`).append(`<span class="${path}"/>`));
    }
    super(jqElement);

    /**
     * @private
     * @type {JQuery}
     */
    this.jqTooltip_ = $('<div class="v-tooltip" />');

    /**
     * @private
     * @type {string|null}
     */
    this.tooltipText_ = null;

    /**
     * @private
     * @type {boolean}
     */
    this.enabled_ = false;

    jqElement.append(this.jqTooltip_.hide());
  }

  /**
   * Enable button
   */
  enable(twoState = true) {
    this.enabled_ = true;
    if (twoState) {
      this.jqElement_.addClass('enabled');
    }
  }

  /**
   * Disable button
   */
  disable() {
    this.enabled_ = false;
    this.jqElement_.removeClass('enabled');
  }

  /**
   * @return {boolean} Return if button is enabled
   */
  isEnabled() {
    return this.enabled_;
  }

  /**
   * @param {string|Array.<string>} svg SVG content
   */
  setSvgPath(svg) {
    const arrSvg = Array.isArray(svg) ? svg : [svg];
    this.jqElement_.append(createSVGIconFromPath(arrSvg.join('')));
  }

  /**
   * @api
   * @param {string} text Text
   */
  setTooltip(text) {
    this.jqTooltip_.text(text);
    this.tooltipText_ = text;
    this.jqElement_.on('mouseover', (e) => {
      if (this.tooltipText_ && this.tooltipText_.length > 0 && $(e.target).hasClass('v-control-button')) {
        this.jqTooltip_.show();
      }
    });
    this.jqElement_.on('mouseleave', () => this.jqTooltip_.hide());
    this.jqTooltip_.on('mouseover', () => this.jqTooltip_.hide());
  }
}

export default VControlButton;
